import { render, staticRenderFns } from "./MatterManage.vue?vue&type=template&id=462eeb38&scoped=true"
import script from "./MatterManage.vue?vue&type=script&lang=js"
export * from "./MatterManage.vue?vue&type=script&lang=js"
import style0 from "./MatterManage.vue?vue&type=style&index=0&id=462eeb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462eeb38",
  null
  
)

export default component.exports